import {NgModule} from '@angular/core';
import {UserUtil} from '../utils/UserUtil';
import {CityService} from '../service/city.service';
import {StateService} from '../service/state.service';
import {MatInputModule} from '@angular/material/input';
import {CoolStorageModule} from '@angular-cool/storage';
import {IntroComponent} from '../intro/intro.component';
import {TooltipModule} from '../tooltip/tooltip.module';
import {LeftDivModule} from '../leftdiv/left-div.module';
import {StorageService} from '../service/storage.service';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {UserInteractor} from '../interactors/user.interactor';
import {CityInteractor} from '../interactors/city.interactor';
import {IntroStep} from '../application-flow/steps/intro.step';
import {EmailStep} from '../application-flow/steps/email.step';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {StateInteractor} from '../interactors/state.interactor';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {LoanInfoComponent} from '../loan-info/loan-info.component';
import {UserAddressService} from '../service/user-address.service';
import {LoanApplicationResolver} from './loan-application.resolver';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {LoanApplicationService} from '../service/loan-application.service';
import {CommonSectionsModule} from '../views/common/common-sections.module';
import {UserAddressInteractor} from '../interactors/user-address.interactor';
import {LoanApplicationFlowComponent} from './loan-application-flow.component';
import {PersonalInfoComponent} from '../personal-info/personal-info.component';
import {BasicLoanInfoStep} from '../application-flow/steps/basic-loan-info.step';
import {ReferralInputComponent} from '../referral-input/referral-input.component';
import {PanVerificationStep} from '../application-flow/steps/pan-verification.step';
import {LoanApplicationInteractor} from '../interactors/loan-application.interactor';
import {LoanApplicationFlowRoutingModule} from './loan-application-flow-routing.module';
import {PhoneVerificationStep} from '../application-flow/steps/phone-verification.step';
import {EmailVerificationModule} from '../email-verification/email-verification.module';
import {LoanApplicationFlowGuard} from '../application-flow/loan-application-flow.guard';
import {PersonalInformationStep} from '../application-flow/steps/personal-information.step';
import {PhoneVerificationComponent} from '../phoneverification/phone-verification.component';
import {LoanApplicationFlowSteps} from '../application-flow/steps/loan-application-flow.steps';
import {LivelihoodInformationStep} from '../application-flow/steps/livelihood-information.step';
import {LoanApplicationFlowNavigator} from '../application-flow/loan-application-flow.navigator';
import {CommonApplicationFlowModule} from '../commons-application-flow/common-application-flow.module';
import {LoanApplicationPanVerificationComponent} from '../pan-verification/pan-verification.component';
import {LivelihoodInformationComponent} from '../livelihood-information/livelihood-information.component';
import {
    MatAutocompleteModule,
    MatButtonModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTabsModule
} from '@angular/material';
import {ProfessionInteractor} from '../interactors/profession.interactor';
import {ProfessionService} from '../service/profession.service';
import {IndustryService} from '../service/industry.service';
import {IndustryInteractor} from '../interactors/industry.interactor';
import {LivelihoodInformationInteractor} from '../interactors/livelihood-information.interactor';
import {LivelihoodInformationService} from '../service/livelihood-information.service';
import {BorrowedInfoStep} from '../application-flow/steps/borrowed-info.steps';
import {BorrowedInfoInteractor} from '../interactors/borrowed-info.interactor';
import {BorrowedInfoService} from '../service/borrowed-info.service';
import {BorrowedInfoComponent} from '../borrowed-info/borrowed-info.component';
import {ResidenceProofStep} from '../application-flow/steps/residence-proof.step';
import {ResidenceProofComponent} from '../residence-proof/residence-proof.component';
import {UploadDocumentsStep} from '../application-flow/steps/upload-documents.step';
import {UploadDocumentsComponent} from '../upload-documents/upload-documents.component';
import {FileUploadModule} from '../file-upload/file-upload.module';
import {BankDetailStep} from '../application-flow/steps/bank-details.step';
import {BorrowerBankDetailsComponent} from '../borrower-bank-details/borrower-bank-details.component';
import {BankDetailsByIfscComponent} from '../bank-details/bank-details-by-ifsc/bank-details-by-ifsc.component';
import {BankInteractor} from '../interactors/bank.interactor';
import {BankService} from '../service/bank.service';
import {BankAccountInteractor} from '../interactors/bank-account.interactor';
import {BankAccountService} from '../service/bank-account.service';
import {BankDetailsByNameComponent} from '../bank-details/bank-details-by-name/bank-details-by-name.component';
import {BankAccountDetailsComponent} from '../bank-account-details/bank-account-details.component';
import {BankAccountResolver} from '../borrower-bank-details/bank-account.resolver';
import {FileInteractor} from '../file-upload/file.interactor';
import {FileService} from '../service/file.service';
import {UploadDocumentsResolver} from '../upload-documents/upload-documents.resolver';
import {BorrowerSummaryComponent} from '../borrow/summary/borrower-summary.component';
import {BorrowerSummaryStep} from '../application-flow/steps/borrower-summary.step';
import {LoanApplicationComponentStepMapper} from '../application-flow/loan-application-component-step.mapper';
import {BorrowerSummaryResolver} from '../borrow/summary/borrower-summary.resolver';
import {IndianCurrencyFormatterModule} from '../views/common/indian-currency-formatter/indian-currency-formatter.module';
import {OnlyNumberDirective} from '../utils/directives/only-number.directive';
import {MaskedAadhaarInfoModule} from '../masked-aadhaar-info/masked-aadhaar-info.module';
import {UserDocumentInteractor} from '../interactors/user-document.interactor';
import {UserDocumentService} from '../service/user-document.service';
import {ResidenceProofResolver} from '../residence-proof/residence-proof.resolver';
import {CreditAssessmentService} from '../service/credit-assessment.service';
import {ConsentService} from '../service/consent.service';
import {CreditAssessmentInfoResolver} from '../borrow/eligibility-check/credit-assessment-info.resolver';
import {ObligationsResolver} from '../resolvers/obligations.resolver';
import {IncomeResolver} from '../resolvers/income.resolver';
import {ButtonModule} from '../views/common/button/button.module';
import { CameraDirectiveModule } from '../directives/camera-directive.module';
import { BrowserUtil } from '../utils/browser.util';

const steps: any[] = [IntroStep, BasicLoanInfoStep, PanVerificationStep, PhoneVerificationStep, EmailStep,
    PersonalInformationStep, LivelihoodInformationStep, BorrowedInfoStep, ResidenceProofStep, BankDetailStep,
    UploadDocumentsStep, BorrowerSummaryStep];

@NgModule({
    declarations: [
        IntroComponent,
        LoanInfoComponent,
        PersonalInfoComponent,
        ReferralInputComponent,
        PhoneVerificationComponent,
        LoanApplicationFlowComponent,
        LivelihoodInformationComponent,
        BorrowedInfoComponent,
        ResidenceProofComponent,
        BorrowerBankDetailsComponent,
        BankDetailsByIfscComponent,
        BankDetailsByNameComponent,
        BankAccountDetailsComponent,
        LoanApplicationPanVerificationComponent,
        UploadDocumentsComponent,
        BorrowerSummaryComponent,
        OnlyNumberDirective
    ],
    imports: [ CommonApplicationFlowModule, CommonSectionsModule, LeftDivModule, FormsModule, ReactiveFormsModule,
        MatButtonModule, MatInputModule, MatButtonToggleModule, MatProgressSpinnerModule, MatSelectModule, MatCheckboxModule, MatDatepickerModule,
        LoanApplicationFlowRoutingModule, CoolStorageModule, TooltipModule, EmailVerificationModule, MatAutocompleteModule, MatTabsModule,
        FileUploadModule, IndianCurrencyFormatterModule, MaskedAadhaarInfoModule, ButtonModule, MatFormFieldModule, CameraDirectiveModule],
    providers: [LoanApplicationInteractor, ProfessionInteractor, LivelihoodInformationInteractor, LivelihoodInformationService, IndustryInteractor, IndustryService, ProfessionService, UserInteractor, UserAddressInteractor, UserAddressService, LoanApplicationService,
        UserUtil, StorageService, LoanApplicationFlowNavigator, LoanApplicationFlowGuard, LoanApplicationComponentStepMapper, ResidenceProofResolver,
        LoanApplicationFlowSteps, LoanApplicationResolver, CityInteractor, CityService, StateInteractor, StateService,
        ...steps, BorrowedInfoInteractor, BankAccountInteractor, BankAccountService, BankInteractor, BorrowedInfoService,
        BankService, BankAccountResolver, FileInteractor, FileService, UploadDocumentsResolver, BorrowerSummaryResolver, UserDocumentInteractor, UserDocumentService, CreditAssessmentService, ConsentService,
        CreditAssessmentInfoResolver, ObligationsResolver, IncomeResolver,BrowserUtil]
})
export class LoanApplicationFlowModule {
}
